<template>
    <div>
        <h4>{{ 'Calendar 30 days' | trans }}</h4>

        <DaysList
                v-if="editedDay === null"
                v-on:day:edit="editedDay = $event">
        </DaysList>

        <DayEdit
                v-if="editedDay !== null"
                v-bind:initialDay="editedDay"
                v-on:day-edit:close="editedDay = null"
                v-bind:user="user">
        </DayEdit>
    </div>
</template>

<script>
    // sadly, use of webpack resolve alias doesn't enable phpstorm link to source...
    import DaysList from './DaysList';
    import DayEdit from './DayEdit';

    export default {
        props: {
            user: Object
        },
        data() {
            return {
                editedDay: null,
            }
        },
        components: {DaysList, DayEdit}
    }
</script>

<style scoped lang="scss">
</style>
